import  { useState,useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  closeProductModal,
  refreshProductList,
} from "../../../redux/features/productModalSlice";
import { AddModule } from "../../../redux/services/moduleService/module.Services";
import Swal from "sweetalert2";
import { successToast } from "../../../Utils/toast";
function CreateModule({ refreshData }) {
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    // description: "",
    status: 1,
  });


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };
  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = ["Name is required"];
    }

    setErrors(newErrors);
    return newErrors;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setTimeout(() => {
        const firstErrorField = document.querySelector(".is-invalid");
        if (firstErrorField) {
          firstErrorField.focus();
          firstErrorField.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
      return;
    }

    try {
      const res = await AddModule(formData);
      if (res?.success) {
       successToast( res.message);
        refreshData?.();
        dispatch(refreshProductList());
        dispatch(closeProductModal());
      }

    } catch (error) {
      if (error?.response?.status === 422) {
        setErrors(error.response.data.errors || {});
      } else {
        Swal.fire("Error", "Something went wrong", "error");
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>

       <div className="mb-3">
        <label> Name <span className="text-danger">*</span></label>
        <input
          type="text"
          name="name"
          className={`form-control ${errors?.name ? "is-invalid" : ""}`}
          placeholder="Module Name"
          value={formData.name}
          onChange={handleChange}
        />
        {errors?.name && (
          <div className="invalid-feedback d-block">
            {errors.name[0]}
          </div>
        )}
      </div>

      <button className="add-btn">
        Create Module
      </button>
    </form>
  );
}

export default CreateModule;